import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedItemGroupType: {
      name: null,
      image: null,
      order: null,
    },
    itemGroupTypes: [],
  }),

  mutations: {
    setSelectedItemGroupType(state, itemGroupType) {
      Vue.set(state, "selectedItemGroupType", itemGroupType);
    },
    setItemGroupTypes(state, itemGroupTypes) {
      Vue.set(state, "itemGroupTypes", itemGroupTypes);
    },
    setDefaultItemGroupTypeModule(state, itemGroupTypes) {
      Vue.set(state, "selectedItemGroupType", {
        name: null,
        image: null,
        order: null,
      });
      Vue.set(state, "itemGroupTypes", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createItemGroupType: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/item-group-types/entity", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadItemGroupTypes: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/item-group-types/entity").then((response) => {
        context.commit("setItemGroupTypes", response.data);
        return response.data;
      });
    },
    loadItemGroupType: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-group-types/entity/" + request.id).then((response) => {
        context.commit("setSelectedItemGroupType", response.data);
      });
    },
    loadPublishedItemGroupTypes: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/item-group-types/entity/published").then((response) => {
        //TODO: Loader koyulacak
        context.commit("setItemGroupTypes", response.data);
        return response.data;
      });
    },
    loadItemGroupTypeHistory: (context, request) => {
      //TODO: Loader start
      return axios.post(context.getters.getMcServiceUrl + "/item-group-types/entity/history/search", request, {}).then((response) => {
        //TODO: Loader end
        return response.data;
      });
    },
    loadSelectedItemGroupTypeHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-group-types/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteItemGroupType: (context, item) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/item-group-types/entity/" + item.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          item.intents = intents;
          item.intentId = response.data.id;
          return item;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftItemGroupType: (context, item) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/item-group-types/draft/" + item.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    publishItemGroupType: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-group-types/publish/" + item.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectItemGroupType: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-group-types/reject/" + item.intentId).then((response) => {
        if (item.intents[0].type === "DELETE_ITEM_TYPE_GROUP") {
          item.intents = null;
          item.intentId = 0;
        } else if (item.intents[0].type === "CREATE_ITEM_TYPE_GROUP") {
          item.intents[0].status = "DRAFT";
        } else if (item.intents[0].type === "UPDATE_ITEM_TYPE_GROUP") {
          item.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },
    sendToApprovalItemGroupType: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-group-types/sendToApproval/" + item.intentId).then((response) => {
        if (item.intents[0].type === "CREATE_ITEM") {
          item.intents[0].status = "WAITING_APPROVAL";
        } else if (item.intents[0].type === "UPDATE_ITEM") {
          item.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallItemGroupType: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-group-types/recall/" + item.intentId).then((response) => {
        helper.recallOrRejectEntity(item, "item_group_type");
        return response.data;
      });
    },

    cancelItemGroupType: (context, item) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-group-types/cancel/" + item.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedItemGroupType: (state) => {
      return state.selectedItemGroupType;
    },
    getItemGroupTypes: (state) => {
      return state.itemGroupTypes;
    },
  },
};
